import { TextField, useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import FormFieldBase from './FormFieldBase';
import { useState } from 'react';

function FormEmailField({
                          label = 'Email',
                          placeholder = 'Ingrese su email',
                          field,
                          width = '100%',
                          disabled = false,
                          rows = 1,
                          onBlur,
                        }) {
  const theme = useTheme();
  const style = styles(theme, width);
  const [tempValue, setTempValue] = useState(field.value);
  const [error, setError] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
      <FormFieldBase>
        <TextField
            placeholder={placeholder || label}
            label={label}
            InputLabelProps={{ shrink: !!tempValue }}
            disabled={disabled}
            multiline={rows > 1}
            rows={rows}
            style={style.fieldContainer}
            value={tempValue}
            error={error}
            helperText={error ? 'Ingrese un email válido' : ''}
            onChange={(event) => {
              const value = event.target.value;
              const emailIsPresentAndInvalid = value !== '' && !validateEmail(value);
              setTempValue(value);
              setError(emailIsPresentAndInvalid);
            }}
            onBlur={(event) => {
              const newValue = event.target.value;
              const emailIsValidAndEdited = validateEmail(newValue) && newValue !== field.initialValue();
              if (emailIsValidAndEdited) {
                field.updateInitialValue(newValue);
                field.updateValue(newValue);
                if (onBlur) {
                  onBlur(event);
                }
              }
            }}
        />
      </FormFieldBase>
  );
}

const styles = (theme, width) => ({
  fieldContainer: {
    backgroundColor: theme.brand.field,
    justifyContent: 'center',
    borderRadius: '0.5rem',
    width: width,
  },
});

export default observer(FormEmailField);
